import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getConstructionProfileFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    startDepth: z
      .number({
        required_error: t("captures.capture.construction-profile.errors.start-depth-required"),
        invalid_type_error: t("captures.capture.construction-profile.errors.start-depth-required"),
      }),
    endDepth: z
      .number({
        required_error: t("captures.capture.construction-profile.errors.end-depth-required"),
        invalid_type_error: t("captures.capture.construction-profile.errors.end-depth-invalid"),
      }),
    variableId: z.number().nullable().optional(),
    value: numberField.optional(),
    drainLength: numberField.optional(),
    notes: z.string().nullable().optional(),
  });
};

export type ConstructionProfileForm = z.infer<ReturnType<typeof getConstructionProfileFormSchema>>;